import React from "react";
import PropTypes from "prop-types";
import styles from "components/documents/active-filters.scss";
import { labelForExportType } from "components/documents/filters/export-type-selector";
import { ActiveFilterItem } from "./active-filter-item";

export const ActiveFilters = ({
  exportType,
  isExports,
  onClearExportType,
  onRemoveCardNumber,
  onRemoveCategory,
  onRemoveCurrency,
  onRemoveDocumentType,
  onRemoveEnvelope,
  onRemoveNameFromFilter,
  onRemovePaymentType,
  onRemoveSearchQuery,
  onRemoveVendor,
  onRemoveViewedStatus,
  searchQueryString,
  selectedCardNumbers,
  selectedCategories,
  selectedCurrencies,
  selectedDocumentType,
  selectedEnvelopes,
  selectedName,
  selectedPaymentTypes,
  selectedVendors,
  viewedStatus
}) => {
  const isEmptyResult = isEmpty(
    searchQueryString,
    selectedCardNumbers,
    selectedCategories,
    selectedCurrencies,
    selectedDocumentType,
    selectedDocumentType,
    selectedVendors,
    selectedName,
    selectedPaymentTypes,
    selectedEnvelopes,
    exportType,
    viewedStatus
  );
  if (isEmptyResult) {
    return null;
  }
  return (
    <div className={ styles.container }>
      { renderExportFilter(isExports) }
      { renderSearchQuery("document type", selectedDocumentType, onRemoveDocumentType) }
      { renderSelectedItems("categories", selectedCategories, onRemoveCategory) }
      { renderSelectedItems("currencies", selectedCurrencies, onRemoveCurrency) }
      { renderSelectedItems("envelopes", selectedEnvelopes, onRemoveEnvelope) }
      { renderSelectedExportType(exportType, onClearExportType) }
      { renderSelectedItems("payment types", selectedPaymentTypes, onRemovePaymentType) }
      { renderSelectedItems("vendors", selectedVendors, onRemoveVendor) }
      { renderSelectedItems("card numbers", selectedCardNumbers, onRemoveCardNumber) }
      { renderSearchQuery("search query", searchQueryString, onRemoveSearchQuery) }
      { renderSearchQuery("name", selectedName, onRemoveNameFromFilter) }
      { renderViewedStatus("viewed status", viewedStatus, onRemoveViewedStatus) }
    </div>
  );
};

ActiveFilters.propTypes = {
  exportType: PropTypes.string,
  isExports: PropTypes.bool.isRequired,
  onClearExportType: PropTypes.func.isRequired, // (string) => void
  onRemoveCardNumber: PropTypes.func.isRequired, // (string) => void
  onRemoveCategory: PropTypes.func.isRequired, // (string) => void
  onRemoveCurrency: PropTypes.func.isRequired, // (string) => void
  onRemoveDocumentType: PropTypes.func.isRequired,
  onRemoveEnvelope: PropTypes.func.isRequired, // (string) => void
  onRemoveNameFromFilter: PropTypes.func,
  onRemovePaymentType: PropTypes.func.isRequired, // (string) => void
  onRemoveSearchQuery: PropTypes.func,
  onRemoveVendor: PropTypes.func.isRequired, // (string) => void
  onRemoveViewedStatus: PropTypes.func.isRequired,
  searchQueryString: PropTypes.string,
  selectedCardNumbers: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedCurrencies: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedDocumentType: PropTypes.string,
  selectedEnvelopes: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedName: PropTypes.string,
  selectedPaymentTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedVendors: PropTypes.arrayOf(PropTypes.string).isRequired,
  viewedStatus: PropTypes.string.isRequired
};

ActiveFilters.defaultProps = {
  exportType: null,
  name: "",
  onRemoveSearchQuery: null,
  onRemoveName: null,
  onRemoveNameFromFilter: null,
  searchQueryString: null,
  selectedDocumentType: null,
  selectedName: null
};

const renderSelectedExportType = (exportType, onClearExportType) => (
  exportType === null ? null : renderSelectedItems("export type", [labelForExportType(exportType)], onClearExportType)
);

const renderSelectedItems = (name, items, onRemoveItem) => {
  if (items.length === 0) {
    return null;
  }
  return (
    <div className={ styles["active-filter-group"] }>
      <span className={ styles["group-title"] }>Selected { name }</span>
      <div>
        { items.map(item => renderItem(item, onRemoveItem, name)) }
      </div>
    </div>
  );
};

const renderSearchQuery = (name, item, onRemoveItem) => {
  if (item === null || item === "") {
    return null;
  }
  return (
    <div className={ styles["active-filter-group"] }>
      <span className={ styles["group-title"] }>Selected { name }</span>
      <div>
        { renderItem(item, onRemoveItem, name) }
      </div>
    </div>
  );
};

const renderViewedStatus = (name, item, onRemoveItem) => {
  if (item === "") {
    return null;
  }
  return (
    <div className={ styles["active-filter-group"] }>
      <span className={ styles["group-title"] }>Selected {name}</span>
      <div>
        {renderItem(item, onRemoveItem, name)}
      </div>
    </div>
  );
};

const renderItem = (item, onRemoveItem, name) => (
  <span key={ `${name}-${item}` }>
    <ActiveFilterItem name={ item } onRemove={ onRemoveItem } />
  </span>
);

const isEmpty = (
  searchQueryString,
  selectedCardNumbers,
  selectedCategories,
  selectedCurrencies,
  selectedDocumentType,
  selectedVendors,
  selectedName,
  selectedPaymentTypes,
  selectedEnvelopes,
  exportType
) => (
  searchQueryString === null
    && selectedName === null
    && selectedCardNumbers.length === 0
    && selectedCategories.length === 0
    && selectedCurrencies.length === 0
    && selectedDocumentType === null
    && selectedVendors.length === 0
    && selectedPaymentTypes.length === 0
    && selectedEnvelopes.length === 0
    && exportType === null
);

const renderExportFilter = (isExports) => {
  if (isExports) {
    return (
      <div className={ styles["active-filter-group"] }>
        <span className={ styles["group-title"] }>Export page filter</span>
        <div>
          {renderItem("Has not been exported", null, "not-exported")}
        </div>
      </div>
    );
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/js/components/documents/filters/active-filters.jsx